import React, { useEffect } from 'react';
import { translate } from '@shakkerai/util-i18n';
import { useLoadings, getLoadings } from '@shakkerai/pro-store';
import { requestCutoutImage } from '@shakkerai/services';
import { getImageOssPath, getCDNImage } from '@shakkerai/util-image';
import { notifySuccess, notifyError } from '@shakkerai/pro-components';
import { inferenceAPIBucket } from '@shakkerai/pro-utils';
import { Loader } from '@mantine/core';
import { updateElement } from '@starflow/app/helpers/canvas';

export const RemoveBackground = ({ element }) => {
  const cutting = useLoadings(element?.id + '-cutting');
  const { startLoading, stopLoading } = getLoadings();
  useEffect(() => {
    (async () => {
      startLoading(element?.id + '-cutting');
      try {
        const { images } = await requestCutoutImage({
          images: [getImageOssPath(element.url)],
          mode: 1,
          ...inferenceAPIBucket,
        });
        // debugger

        if (Array.isArray(images) && images[0]) {
          updateElement(element?.id, {
            url: getCDNImage(images[0]),
          });

          notifySuccess(translate('image_cutout_success'));
        } else {
          throw new Error(translate('image_cutout_error'));
        }
      } catch (error) {
        notifyError(translate('image_cutout_error'), translate('image_cutout_error_sub'));
      } finally {
        stopLoading(element?.id + '-cutting');
      }
    })();
  }, []);
  return <RemoveBackgroundMask cutting={cutting} />;
};

export const RemoveBackgroundMask = ({ cutting }) => {
  return cutting ? (
    <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-auto bg-white/80">
      <Loader size={16} />
      <span className="mt-1 text-mini whitespace-nowrap text-caption-500">{translate('image_cutting')}</span>
    </div>
  ) : null;
};
